// Client helper to trigger the server-side email worker.
// Authenticates with the current Supabase session JWT so the worker can verify
// the request without needing the WORKER_SECRET in the browser.
import { supabase } from '../supabaseClient';

const WORKER_BASE = process.env.REACT_APP_EMAIL_WORKER_BASE || '';

async function getAuthToken() {
  try {
    const { data } = await supabase.auth.getSession();
    return data?.session?.access_token || null;
  } catch {
    return null;
  }
}

async function sendEmailTrigger({ templateName, to, vars = {}, subject } = {}) {
  const token = await getAuthToken();
  const url = `${WORKER_BASE}/email/send`;

  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify({ templateName, to, vars, subject })
  });

  if (!res.ok) {
    const txt = await res.text();
    throw new Error(`Email trigger failed: ${res.status} ${txt}`);
  }

  return res.json();
}

const emailHelpers = { sendEmailTrigger };

export default emailHelpers;

